import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconTwitter16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconTwitter16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M12.772 5.992q.009.13.007.26c0 2.67-2.477 5.748-7.005 5.748v-.002C4.436 12 3.126 11.686 2 11.093q.292.03.586.03c1.109 0 2.185-.305 3.058-.867-1.054-.017-1.978-.58-2.3-1.403.369.058.749.046 1.111-.035C3.307 8.628 2.48 7.8 2.48 6.838v-.025c.342.156.726.243 1.118.253-1.082-.594-1.416-1.774-.762-2.698 1.25 1.262 3.094 2.03 5.074 2.11-.199-.7.072-1.436.712-1.93.991-.764 2.55-.725 3.483.088a5.6 5.6 0 0 0 1.563-.49c-.183.468-.568.865-1.082 1.117A5.8 5.8 0 0 0 14 4.945a4.6 4.6 0 0 1-1.229 1.047"
            />
        </svg>
    );
}
export default memo(IconTwitter16);
